export default "__VITE_ASSET__C27piqwo__"